import React from "react";

/**
 * Top-Level Error Boundary.
 * Faengt unbehandelte Render-Fehler ab, damit die SPA nicht in eine
 * weisse Seite umkippt. Zeigt eine minimale Fallback-UI mit Reload-Knopf.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, errorInfo);
    // Optionaler Hook fuer spaeteres Sentry/Crashlytics-Integration
    if (typeof window !== "undefined" && typeof window.onAppError === "function") {
      try {
        window.onAppError(error, errorInfo);
      } catch (_) {
        // ignore
      }
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          fontFamily: "system-ui, -apple-system, sans-serif",
          background: "#f7f7f9",
        }}
      >
        <div
          style={{
            maxWidth: 480,
            background: "white",
            borderRadius: 8,
            padding: "2rem",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            textAlign: "center",
          }}
        >
          <h1 style={{ margin: "0 0 0.75rem", fontSize: "1.5rem", color: "#1a1a1a" }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ color: "#555", margin: "0 0 1.5rem", lineHeight: 1.5 }}>
            Die Anwendung hat einen unerwarteten Fehler erkannt. Bitte lade die
            Seite neu. Der Fehler wurde protokolliert.
          </p>
          {process.env.NODE_ENV !== "production" && this.state.error && (
            <pre
              style={{
                textAlign: "left",
                background: "#f0f0f3",
                padding: "0.75rem",
                borderRadius: 4,
                fontSize: "0.8rem",
                overflow: "auto",
                maxHeight: 200,
                margin: "0 0 1rem",
              }}
            >
              {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
            </pre>
          )}
          <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                background: "#0070f3",
                color: "white",
                border: 0,
                padding: "0.6rem 1.2rem",
                borderRadius: 4,
                cursor: "pointer",
                fontSize: "0.95rem",
              }}
            >
              Seite neu laden
            </button>
            <button
              type="button"
              onClick={this.handleGoHome}
              style={{
                background: "white",
                color: "#0070f3",
                border: "1px solid #0070f3",
                padding: "0.6rem 1.2rem",
                borderRadius: 4,
                cursor: "pointer",
                fontSize: "0.95rem",
              }}
            >
              Zur Startseite
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
